export const validation = {
  amountType: 'Please enter the amount pay',
  cardHolder: 'Please enter the card holder',
  cardNumber: 'Please enter the card number',
  expMonth: 'Expire month is required',
  expYear: 'Expire year is required',
  cvv: 'Please enter the cvv',
  checkNumber: 'Please enter the check number',
  bankName: 'Please enter the bank name',
  finance: 'Please enter the financing confirmation number',
  paymentReceipt: 'Payment receipt is required',
  typeOfModel: 'Please enter the type of model/Browser',
  typeOfPhone: 'Please choose the type of phone',
  issueStatus: 'Please choose the issue status',
  issueDetail: 'Please enter the issue detail',
  issueMedia1: 'Media is required',
  resolvedIssueDetail: 'Please enter the resolved issue detail',
  notResolveIssueDetail: 'Please enter the not resolve issue detail',
  supplyHouseId: 'Please choose the supply house',
  maxValidDetails: 'Please enter less than 1000 characters.',
  cardHolderMax: 'Please enter less than 50 characters.',
};
